module.exports = __webpack_public_path__ + "static/media/reject.0994e9fc.svg";